import './DeleteFile.css'
import { AiOutlineDownload } from 'react-icons/ai';
import { Amplify, Storage } from "aws-amplify";
import awsconfig from "../aws-exports";
import JSZip from "jszip";
import { Tooltip } from '@mui/material';
Amplify.configure(awsconfig);

function DownloadFile(props) {

    const { /*bucketname,*/ file } = props

    const downloadFile = async () => {
        try {
            if (file.key !== undefined) {
                // Handle file download (your existing code)
                const response = await Storage.get(file.key, {
                    // bucket: bucketname,
                    level: 'private',
                    download: true,
                    expires: 900
                });

                const url = URL.createObjectURL(response.Body);
                const a = document.createElement("a");
                a.href = url;
                a.download = file.key;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);
            }
            else {
                const response = await Storage.list(file.endsWith('/') ? file : file + '/', {
                    // bucket: bucketname,
                    level: 'private',
                });

                const zip = new JSZip();
                const downloadPromises = [];

                for (let item of response.results) {
                    downloadPromises.push(
                        Storage.get(item.key, {
                            // bucket: bucketname,
                            level: 'private',
                            download: true
                        }).then(response => {
                            const fileBlob = response.Body;
                            zip.file(item.key, fileBlob);
                        })
                    );
                }

                // Wait for all files to be added to the zip
                await Promise.all(downloadPromises);

                // Generate the zip file
                const content = await zip.generateAsync({ type: "blob" });

                // Download the zip
                const url = URL.createObjectURL(content);

                const a = document.createElement("a");
                a.href = url;
                a.download = `${file}.zip`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);
            }
        }
        catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    return <>
        <Tooltip title="Download" placement='top'>
            <button onClick={downloadFile} className='delete-button' id='download' ><AiOutlineDownload className='delete-button__icon' /></button>
        </Tooltip>
    </>

}

export default DownloadFile